var map = {
	"./bio-based-waste-stream-biocomposite/block-large.png": [
		6466,
		6466
	],
	"./biochar-based-bioplastic/block-large.png": [
		607,
		607
	],
	"./biodegradable-and-bio-based-materials/block-large.png": [
		6155,
		6155
	],
	"./biodegradable-biopolymer/block-large.png": [
		3100,
		3100
	],
	"./cellulose-acoustic-panel/block-large.png": [
		171,
		171
	],
	"./compostable-foam/block-large.png": [
		9329,
		9329
	],
	"./cork-based-material/block-large.png": [
		4984,
		2603
	],
	"./fish-scale-board/block-large.png": [
		1372,
		1372
	],
	"./kraft-lignin/block-large.png": [
		2704,
		2704
	],
	"./lignin-nanoparticles/block-large.png": [
		8004,
		8004
	],
	"./microalgae-derived-zero-carbon-bio-cement/block-large.png": [
		8405,
		8405
	],
	"./mycelium-based-acoustic-panels/block-large.png": [
		9543,
		9543
	],
	"./mycelium-based-building-material/block-large.png": [
		1234,
		1234
	],
	"./osl/block-large.png": [
		496,
		496
	],
	"./plastic-free-leather/block-large.png": [
		7543,
		7543
	],
	"./polycrystalline-silicon/block-large.png": [
		6280,
		6280
	],
	"./recycled-paper-boards/block-large.png": [
		2464,
		2464
	],
	"./recycled-paper-composite/block-large.png": [
		1374,
		1374
	],
	"./recycled-paper-panel/block-large.png": [
		9185,
		9185
	],
	"./seaweed-paper/block-large.png": [
		9597,
		9597
	],
	"./sodium-lignosulfonate/block-large.png": [
		9708,
		9708
	],
	"./starch-based-composite/block-large.png": [
		9537,
		9537
	],
	"./waste-leaf-paper/block-large.png": [
		9774,
		9774
	],
	"./water-resistant-lignin-coating/block-large.png": [
		7099,
		7099
	],
	"./wood-based-plastic-alternative/block-large.png": [
		7604,
		7604
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3895;
module.exports = webpackAsyncContext;